import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const HomeRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.hash?.indexOf('#/candidate-job-board-profile') > -1) {
      const paths = window.location.hash.split('#')[1].split('?');
      window.location.href = `${window.location.origin}${paths[0]}?${paths[1]}`;
    } else {
      navigate('/home');
    }
  }, [navigate]);

  return <></>;
};
